<template>
  <div class="m-pills__pill">
    <button class="m-pills__close-btn" @click="close" title="Enlever" />
    <span class="m-pills__label">{{ label }}</span>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    }
  },
  methods: {
    close: function() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
.m-pills {
  font-size: 16px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-bottom: spacing('light');

  &__pill-stash {
    margin: 0 (spacing('thin') / -2) (spacing('light') - spacing('thin'));
    flex-basis: 100%;
  }
  
  &__pill {
    background-color: color('primary');
    display: inline-flex;
    align-items: center;
    padding: spacing('thin') ($margin-base / 2);
    border-radius: 26px;
    color: color('white');
    margin: 0 (spacing('thin') / 2) spacing('thin');
  }

  &__label {
    font-weight: 600;
    line-height: 1.2;
  }

  &__close-btn,
  &__reset-btn {
    @include btn-default-properties;
  }

  &__close-btn {
    background: #7667a7 url(~@/assets/close-round.svg) no-repeat center center;
    background-size: contain;
    cursor: pointer;
    height: 16px;
    width: 16px;
    margin-right: spacing('thin');
    padding: 0;
    display: block;
  }

  &__reset-btn {
    color: color('primary');
    font-weight: 600;
    text-align: left;
    text-decoration: underline;
    padding: 0;
  }
}
</style>
